/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
import Cart from 'cart-store';

function financial(x) {
    return Number.parseFloat(x / 100).toFixed(2).replace(".", ",");
}

function renderSplitPayment(totalPrice) {
    const element = document.getElementById("custom-cart-split-payment");
    if (!element) return;
    element.innerText = element.getAttribute("data-text").replace("{{amount}}", financial(totalPrice / 3));
}

Cart.subscribe((event) => renderSplitPayment(event.cart.total_price));
renderSplitPayment(Cart.getState().cart.total_price);

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(".custom-clamp").forEach((clampElement) => {
        const seeMore = clampElement.getAttribute("data-see-more");
        const seeLess = clampElement.getAttribute("data-see-less");

        const button = document.createElement("button");
        button.setAttribute("class", "c-btn c-btn--primary c-btn--hollow c-btn--small c-btn--center");
        button.textContent = seeMore;
        button.addEventListener("click", (event) => {
            event.target.parentElement.querySelector(".custom-clamp").classList.toggle("custom-clamp__closed");
            if (event.target.textContent === seeMore) {
                event.target.textContent = seeLess;
            } else {
                event.target.textContent = seeMore;
            }
            event.target.blur();
        });
        clampElement.classList.add("custom-clamp__closed");
        clampElement.parentElement.appendChild(button);
    })
}, { once: true });